import { encode } from 'html-entities';

/**
 * Encodes XML special characters to their entity equivalents to prevent XSS attacks.
 */
export function encodeXMLEntities(str: string): string {
  return encode(str, { mode: 'specialChars', level: 'xml' });
}

/**
 * Validates that a URI is a data URI (base64-encoded image).
 * Only data URIs are allowed for security reasons (prevents e.g. 'javascript:' and 'http:' URLs).
 */
export function validateDataURI(uri: string): string {
  if (uri === '') {
    return uri;
  }
  if (!uri.startsWith('data:')) {
    console.error('Only data URIs are allowed for images');
    return '';
  }
  return uri;
}
